module.exports = __webpack_public_path__ + "images/MonthlyTreatscc5d457796dd030c8168de60d3da6553.jpg";